module.exports = __webpack_public_path__ + "static/media/invite-guest-invalid.d59ad42b.svg";